import { Box, Typography } from '@mui/material';
import React from 'react'
import Tokenaddtab from './Tokenaddtab'

const AddToken = () => {

    return (
        <div>
            <Box className='contact_us'>
                <Box className='createcollection_bg'>
                    <Typography variant='h2' fontWeight='600' fontSize='45px'>
                        Add Token
                    </Typography>
                </Box>
            </Box>
            <Tokenaddtab />
        </div>
    )
}

export default AddToken;